// src/app/pipes/custom-date.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'customDate',
  standalone: true
})
export class CustomDatePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    // Parse the date using moment.js
    const date = moment(value);
    if (!date.isValid()) return '';

    // Format the date to 'DD-MM-YYYY HH:mm'
    return date.format('DD-MM-YYYY HH:mm');
  }
}